export default __webpack_public_path__ + "static/media/AngryPenguin.4320c797.svg";